

// "use client"

// import { Star, Award } from "lucide-react"
// import { ScrollReveal } from "@/components/animations/scroll-reveal"
// import Image from "next/image"

// interface StudentTestimonial {
//   id: string
//   name: string
//   course: string
//   testimonial: string
//   rating: number
//   // placement: {
//   //   company: string
//   //   position: string
//   //   lpa: string
//   // }
//   image: string
// }

// const TESTIMONIALS: StudentTestimonial[] = [
//   {
//     id: "1",
//     name: "Rajesh Kumar",
//     course: "Full Stack Web Development",
//     testimonial:
//       "The instructors at CodifyInstitute are incredibly knowledgeable and supportive. I landed my first developer job within 2 months of completing the course!",
//     rating: 5,
//     // placement: {
//     //   company: "TechCorp India",
//     //   position: "Junior Full Stack Developer",
//     //   lpa: "6.5 LPA",
//     // },
//     image: "/student-rajesh-kumar.jpg",
//   },
//   {
//     id: "2",
//     name: "Priya Sharma",
//     course: "React.js Masterclass",
//     testimonial:
//       "The practical projects and real-world scenarios helped me understand React deeply. The 60% salary hike I got was worth every minute spent here.",
//     rating: 5,
//     // placement: {
//     //   company: "WebSolutions Ltd",
//     //   position: "Senior Frontend Developer",
//     //   lpa: "9.2 LPA",
//     // },
//     image: "/student-priya-sharma.jpg",
//   },
//   {
//     id: "3",
//     name: "Amit Patel",
//     course: "Python for Data Science",
//     testimonial:
//       "Excellent curriculum and mentorship. The data science skills I learned helped me transition from IT support to a data analyst role seamlessly.",
//     rating: 5,
//     // placement: {
//     //   company: "DataInsight Analytics",
//     //   position: "Data Analyst",
//     //   lpa: "7.5 LPA",
//     // },
//     image: "/student-amit-patel.jpg",
//   },
//   {
//     id: "4",
//     name: "Sneha Desai",
//     course: "Node.js Backend Development",
//     testimonial:
//       "The backend development course was comprehensive. I now handle microservices architecture at my current role. Highly recommended!",
//     rating: 5,
//     // placement: {
//     //   company: "CloudFirst Systems",
//     //   position: "Backend Engineer",
//     //   lpa: "8.75 LPA",
//     // },
//     image: "/student-sneha-desai.jpg",
//   },
//   {
//     id: "5",
//     name: "Vikram Singh",
//     course: "Advanced TypeScript",
//     testimonial:
//       "TypeScript concepts were intimidating initially, but the structured teaching made it crystal clear. Landed a job at a FAANG company!",
//     rating: 5,
//     // placement: {
//     //   company: "InnovateTech Global",
//     //   position: "Senior Software Engineer",
//     //   lpa: "12.5 LPA",
//     // },
//     image: "/student-vikram-singh.jpg",
//   },
//   {
//     id: "6",
//     name: "Isha Nair",
//     course: "JavaScript Fundamentals",
//     testimonial:
//       "As someone from a non-tech background, the beginner-friendly approach was perfect. Now I work as a frontend developer with confidence.",
//     rating: 5,
//     // placement: {
//     //   company: "DesignFlow Studio",
//     //   position: "Frontend Developer",
//     //   lpa: "5.5 LPA",
//     // },
//     image: "/student-isha-nair.jpg",
//   },
  
// ]

// export function StudentTestimonials() {
//   return (
//     <section className="relative py-24 px-4 sm:px-6 lg:px-8 bg-gradient-to-b from-white to-blue-50 overflow-hidden">
//       <div className="max-w-7xl mx-auto relative z-10">
//         {/* Heading */}
//         <ScrollReveal>
//           <div className="text-center mb-16">
//             <h2 className="font-display font-bold text-4xl md:text-5xl text-gray-900 mb-4 animate-slide-up">
//               Student Success <span className="text-blue-600">Stories</span>
//             </h2>
//             <p className="text-xl text-gray-600 max-w-2xl mx-auto animate-fade-in">
//               See how our alumni have transformed their careers with our comprehensive training programs.
//             </p>
//           </div>
//         </ScrollReveal>

//         {/* Stats Section */}
//         <div className="grid grid-cols-1 md:grid-cols-4 gap-6 mb-20">
//           {[
//             { label: "Students Placed", value: "240+" },
//             { label: "Average Package", value: "3.5LPA" },
//             { label: "Highest Package", value: "20LPA" },
//             { label: "Partner Companies", value: "50+" },
            
//           ].map((stat, idx) => (
//             <ScrollReveal key={idx} delay={idx * 0.1}>
//               <div className="bg-white rounded-2xl p-8 text-center border border-blue-100 shadow-sm hover:shadow-md transition-all duration-500 hover:-translate-y-2">
//                 <div className="text-3xl font-display font-extrabold text-blue-600 mb-2">
//                   {stat.value}
//                 </div>
//                 <p className="text-gray-600 font-medium">{stat.label}</p>
//               </div>
//             </ScrollReveal>
//           ))}
//         </div>

//         {/* Testimonials Grid */}
//         <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
//           {TESTIMONIALS.map((student, idx) => (
//             <ScrollReveal key={student.id} delay={idx * 0.05}>
//               <div className="bg-white rounded-2xl border border-blue-100 shadow-md hover:shadow-lg hover:-translate-y-2 transition-all duration-500 p-8 flex flex-col">
//                 {/* Rating */}
//                 <div className="flex gap-1 mb-4">
//                   {Array.from({ length: student.rating }).map((_, i) => (
//                     <Star key={i} size={16} className="fill-blue-500 text-blue-500" />
//                   ))}
//                 </div>
//                  {/* Student Info */}
//                 <div className="flex items-center gap-3 mb-4 pb-4 border-b border-gray-100">
//                   <div className="w-12 h-12 rounded-full overflow-hidden ring-2 ring-blue-100">
//                     <Image
//                       src={student.image || "/placeholder.svg"}
//                       alt={student.name}
//                       width={48}
//                       height={48}
//                       className="object-cover"
//                     />
//                   </div>
//                   <div>
//                     <p className="font-display font-bold text-gray-900">{student.name}</p>
//                     {/* <p className="text-sm text-gray-600">{student.course}</p> */}
//                   </div>
//                 </div>

//                 {/* Testimonial */}
//                 <p className="text-gray-700 mb-6 flex-1 italic leading-relaxed">
//                   {student.testimonial}
//                 </p>

               

//                 {/* Placement Info */}
//                 {/* <div className="text-sm text-gray-700">
//                   <div className="flex items-center gap-2 text-blue-600 font-semibold mb-2">
//                     <Award size={18} />
//                     <span>Placement Details</span>
//                   </div> */}
//                   {/* <p>
//                     <span className="font-semibold">Company:</span> {student.placement.company}
//                   </p>
//                   <p>
//                     <span className="font-semibold">Position:</span> {student.placement.position}
//                   </p>
//                   <p className="mt-3 font-semibold text-gray-900">
//                     PACKAGE: <span className="text-blue-600">{student.placement.lpa}</span>
//                   </p> */}
//                 {/* </div> */}
//               </div>
//             </ScrollReveal>
//           ))}
//         </div>
//       </div>

//       {/* Smooth background animation */}
//       <div className="absolute inset-0 bg-gradient-to-b from-transparent to-blue-100 opacity-30 animate-gradientMove" />

//       <style jsx>{`
//         .animate-slide-up {
//           animation: slideUp 1s ease-out forwards;
//         }
//         .animate-fade-in {
//           animation: fadeIn 1.5s ease-out forwards;
//         }
//         @keyframes slideUp {
//           from {
//             opacity: 0;
//             transform: translateY(40px);
//           }
//           to {
//             opacity: 1;
//             transform: translateY(0);
//           }
//         }
//         @keyframes fadeIn {
//           from {
//             opacity: 0;
//           }
//           to {
//             opacity: 1;
//           }
//         }
//         @keyframes gradientMove {
//           0% {
//             background-position: 0% 50%;
//           }
//           100% {
//             background-position: 100% 50%;
//           }
//         }
//       `}</style>
//     </section>
//   )
// }


"use client"

import { Star, Award } from "lucide-react"
import { ScrollReveal } from "@/components/animations/scroll-reveal"
import Image from "next/image"

interface StudentTestimonial {
  id: string
  name: string
  course: string
  testimonial: string
  rating: number
  image: string
}

const TESTIMONIALS: StudentTestimonial[] = [
  {
    id: "1",
    name: "Rajesh Kumar",
    course: "Full Stack Web Development",
    testimonial: "The instructors at CodifyInstitute are incredibly knowledgeable and supportive. I landed my first developer job within 2 months of completing the course!",
    rating: 5,
    image: "/students/rajesh-kumar.jpg",
  },
  {
    id: "2",
    name: "Priya Sharma",
    course: "React.js Masterclass",
    testimonial: "The practical projects and real-world scenarios helped me understand React deeply. The 60% salary hike I got was worth every minute spent here.",
    rating: 5,
    image: "/students/priya-sharma.jpg",
  },
  {
    id: "3",
    name: "Amit Patel",
    course: "Python for Data Science",
    testimonial: "Excellent curriculum and mentorship. The data science skills I learned helped me transition from IT support to a data analyst role seamlessly.",
    rating: 5,
    image: "/students/amit-patel.jpg",
  },
  {
    id: "4",
    name: "Sneha Desai",
    course: "Node.js Backend Development",
    testimonial: "The backend development course was comprehensive. I now handle microservices architecture at my current role. Highly recommended!",
    rating: 5,
    image: "/students/sneha-desai.jpg",
  },
  {
    id: "5",
    name: "Vikram Singh",
    course: "Advanced TypeScript",
    testimonial: "TypeScript concepts were intimidating initially, but the structured teaching made it crystal clear. Landed a job at a FAANG company!",
    rating: 5,
    image: "/students/vikram-singh.jpg",
  },
  {
    id: "6",
    name: "Isha Nair",
    course: "JavaScript Fundamentals",
    testimonial: "As someone from a non-tech background, the beginner-friendly approach was perfect. Now I work as a frontend developer with confidence.",
    rating: 5,
    image: "/students/isha-nair.jpg",
  },
  {
    id: "7",
    name: "Arjun Mehta",
    course: "MERN Stack Bootcamp",
    testimonial: "Best decision of my career. Built 5 full-stack apps during the course and got placed in a startup as a Full Stack Engineer.",
    rating: 5,
    image: "/students/arjun-mehta.jpg",
  },
  {
    id: "8",
    name: "Neha Gupta",
    course: "UI/UX Design with Figma",
    testimonial: "From zero design knowledge to creating production-ready interfaces. The portfolio I built here got me 3 job offers!",
    rating: 5,
    image: "/students/neha-gupta.jpg",
  },
  {
    id: "9",
    name: "Rohan Verma",
    course: "DevOps & Cloud (AWS)",
    testimonial: "Learned CI/CD, Docker, Kubernetes, and AWS in 3 months. Now managing cloud infra for a fintech company.",
    rating: 5,
    image: "/students/rohan-verma.jpg",
  },
  {
    id: "10",
    name: "Kavya Reddy",
    course: "Machine Learning with Python",
    testimonial: "The hands-on ML projects were gold. I built a recommendation system that impressed my interviewer at Zomato.",
    rating: 5,
    image: "/students/kavya-reddy.jpg",
  },
  {
    id: "11",
    name: "Siddharth Jain",
    course: "Next.js & App Router",
    testimonial: "Next.js 14 + App Router mastery! Deployed 3 SSR apps and got hired as a Senior Frontend at a SaaS startup.",
    rating: 5,
    image: "/students/siddharth-jain.jpg",
  },
  {
    id: "12",
    name: "Ananya Iyer",
    course: "GraphQL & Apollo",
    testimonial: "Finally understood GraphQL vs REST. Built a full-stack e-commerce app with React + Node + GraphQL. 10/10!",
    rating: 5,
    image: "/students/ananya-iyer.jpg",
  },
  {
    id: "13",
    name: "Yash Malhotra",
    course: "System Design (HLD + LLD)",
    testimonial: "Cracked system design interviews at Google & Microsoft after this course. Worth every rupee.",
    rating: 5,
    image: "/students/yash-malhotra.jpg",
  },
  {
    id: "14",
    name: "Tanya Singh",
    course: "Tailwind CSS Mastery",
    testimonial: "From Bootstrap to Tailwind pro in 2 weeks. Now I build pixel-perfect UIs 3x faster.",
    rating: 5,
    image: "/students/tanya-singh.jpg",
  },
  {
    id: "15",
    name: "Ravi Thakur",
    course: "GoLang for Backend",
    testimonial: "Switched from Node.js to Go. The performance gains are insane. Now building high-throughput APIs.",
    rating: 5,
    image: "/students/ravi-thakur.jpg",
  },
  {
    id: "16",
    name: "Pooja Rao",
    course: "SQL & Database Design",
    testimonial: "Mastered complex joins, indexing, and normalization. Saved my company 40% query time in production.",
    rating: 5,
    image: "/students/pooja-rao.jpg",
  },
  {
    id: "17",
    name: "Karan Bhatia",
    course: "Flutter Mobile Development",
    testimonial: "Built and published 2 apps on Play Store during the course. Got hired by a fintech startup as Mobile Lead.",
    rating: 5,
    image: "/students/karan-bhatia.jpg",
  },
  {
    id: "18",
    name: "Meera Kapoor",
    course: "Cybersecurity Basics",
    testimonial: "Learned ethical hacking, OWASP, and secure coding. Now working as a Security Analyst at Paytm.",
    rating: 5,
    image: "/students/meera-kapoor.jpg",
  },
  {
    id: "19",
    name: "Aditya Sharma",
    course: "Django REST Framework",
    testimonial: "Built 4 REST APIs with authentication, pagination, and testing. Deployed on AWS with Docker.",
    rating: 5,
    image: "/students/aditya-sharma.jpg",
  },
  {
    id: "20",
    name: "Shalini Menon",
    course: "Power BI & Data Visualization",
    testimonial: "From Excel to interactive dashboards. Helped my team save 15 hours/week in reporting.",
    rating: 5,
    image: "/students/shalini-menon.jpg",
  },
  {
    id: "21",
    name: "Nikhil Chopra",
    course: "Kubernetes & Microservices",
    testimonial: "Deployed a 12-microservice app on EKS. Now leading DevOps at a Series B startup.",
    rating: 5,
    image: "/students/nikhil-chopra.jpg",
  },
  {
    id: "22",
    name: "Riya Joshi",
    course: "Vue.js & Nuxt 3",
    testimonial: "Loved the SSR + SSG combo in Nuxt. Built a blog platform that handles 100K monthly users.",
    rating: 5,
    image: "/students/riya-joshi.jpg",
  },
  {
    id: "23",
    name: "Sameer Khan",
    course: "Blockchain & Web3",
    testimonial: "Wrote my first smart contract in Solidity. Now building DeFi tools full-time.",
    rating: 5,
    image: "/students/sameer-khan.jpg",
  },
  {
    id: "24",
    name: "Divya Agarwal",
    course: "Svelte & SvelteKit",
    testimonial: "Svelte is magic! Built a real-time dashboard 60% smaller than React version.",
    rating: 5,
    image: "/students/divya-agarwal.jpg",
  },
  {
    id: "25",
    name: "Vivek Pandey",
    course: "Java Spring Boot",
    testimonial: "Enterprise-grade Java skills in 8 weeks. Now developing banking software at HDFC.",
    rating: 5,
    image: "/students/vivek-pandey.jpg",
  },
  {
    id: "26",
    name: "Simran Kaur",
    course: "AI Prompt Engineering",
    testimonial: "Learned to build AI agents with LangChain. Automating customer support at my company now.",
    rating: 5,
    image: "/students/simran-kaur.jpg",
  },
  {
    id: "27",
    name: "Akash Dubey",
    course: "Redis & Caching Strategies",
    testimonial: "Reduced API latency from 800ms to 80ms using Redis. Game changer!",
    rating: 5,
    image: "/students/akash-dubey.jpg",
  },
  {
    id: "28",
    name: "Lavanya Pillai",
    course: "Three.js & WebGL",
    testimonial: "Built a 3D product visualizer for an e-commerce client. Blew their minds!",
    rating: 5,
    image: "/students/lavanya-pillai.jpg",
  },
  {
    id: "29",
    name: "Rohit Yadav",
    course: "Rust for Systems Programming",
    testimonial: "Rust is tough, but this course made it fun. Now writing memory-safe backend services.",
    rating: 5,
    image: "/students/rohit-yadav.jpg",
  },
  {
    id: "30",
    name: "Sanya Malhotra",
    course: "FastAPI & Async Python",
    testimonial: "Built a high-performance API that handles 10K RPS. FastAPI is now my go-to framework.",
    rating: 5,
    image: "/students/sanya-malhotra.jpg",
  },
]

export function StudentTestimonials() {
  return (
    <section className="relative py-24 px-4 sm:px-6 lg:px-8 bg-gradient-to-b from-white to-blue-50 overflow-hidden">
      <div className="max-w-7xl mx-auto relative z-10">
        {/* Heading */}
        <ScrollReveal>
          <div className="text-center mb-16">
            <h2 className="font-display font-bold text-4xl md:text-5xl text-gray-900 mb-4">
              Student Success <span className="text-blue-600">Stories</span>
            </h2>
            <p className="text-xl text-gray-600 max-w-2xl mx-auto">
              See how our alumni have transformed their careers with our comprehensive training programs.
            </p>
          </div>
        </ScrollReveal>

        {/* Stats Section */}
        <div className="grid grid-cols-1 md:grid-cols-4 gap-6 mb-20">
          {[
            { label: "Students Placed", value: "250+" },
            { label: "Average Package", value: "3.5 LPA" },
            { label: "Highest Package", value: "20 LPA" },
            { label: "Partner Companies", value: "50+" },
          ].map((stat, idx) => (
            <ScrollReveal key={idx} delay={idx * 0.1}>
              <div className="bg-white rounded-2xl p-8 text-center border border-blue-100 shadow-sm hover:shadow-md transition-all duration-500 hover:-translate-y-2">
                <div className="text-3xl font-display font-extrabold text-blue-600 mb-2">
                  {stat.value}
                </div>
                <p className="text-gray-600 font-medium">{stat.label}</p>
              </div>
            </ScrollReveal>
          ))}
        </div>

        {/* Testimonials Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {TESTIMONIALS.map((student, idx) => (
            <ScrollReveal key={student.id} delay={idx * 0.05}>
              <div className="bg-white rounded-2xl border border-blue-100 shadow-md hover:shadow-lg hover:-translate-y-2 transition-all duration-500 p-8 flex flex-col">
                {/* Rating */}
                <div className="flex gap-1 mb-4">
                  {Array.from({ length: student.rating }).map((_, i) => (
                    <Star key={i} size={16} className="fill-blue-500 text-blue-500" />
                  ))}
                </div>

                {/* Student Info */}
                <div className="flex items-center gap-3 mb-4 pb-4 border-b border-gray-100">
                  {/* <div className="w-12 h-12 rounded-full overflow-hidden ring-2 ring-blue-100">
                    <Image
                      src={student.image}
                      alt={student.name}
                      width={48}
                      height={48}
                      className="object-cover"
                      onError={(e) => {
                        e.currentTarget.src = "/placeholder.svg"
                      }}
                    />
                  </div> */}
                  <div>
                    <p className="font-display font-bold text-gray-900">{student.name}</p>
                    {/* <p className="text-sm text-gray-600">{student.course}</p> */}
                  </div>
                </div>

                {/* Testimonial */}
                <p className="text-gray-700 mb-6 flex-1 italic leading-relaxed">
                  "{student.testimonial}"
                </p>

                {/* Optional: Uncomment when placement data is ready */}
                {/* {student.placement && (
                  <div className="text-sm text-gray-700 mt-auto pt-4 border-t border-gray-100">
                    <div className="flex items-center gap-2 text-blue-600 font-semibold mb-2">
                      <Award size={18} />
                      <span>Placed at {student.placement.company}</span>
                    </div>
                    <p className="font-semibold text-gray-900">
                      PACKAGE: <span className="text-blue-600">{student.placement.lpa}</span>
                    </p>
                  </div>
                )} */}
              </div>
            </ScrollReveal>
          ))}
        </div>
      </div>

      {/* Background Animation */}
      <div className="absolute inset-0 bg-gradient-to-b from-transparent to-blue-100 opacity-30 animate-gradientMove" />

      <style jsx>{`
        @keyframes slideUp {
          from { opacity: 0; transform: translateY(40px); }
          to { opacity: 1; transform: translateY(0); }
        }
        @keyframes fadeIn {
          from { opacity: 0; }
          to { opacity: 1; }
        }
        @keyframes gradientMove {
          0% { background-position: 0% 50%; }
          100% { background-position: 100% 50%; }
        }
        .animate-gradientMove {
          animation: gradientMove 20s ease infinite alternate;
        }
      `}</style>
    </section>
  )
}